// extracted by mini-css-extract-plugin
export default {"box":"inventorySparesListingPage_box__QUy7f"};